import { t } from '@lingui/macro';
import { useLocale } from 'hooks/useLocale';
import { TDateUnit, TSingleApplication } from 'lendingApi/applications.types';

const durationUnits = {
  months: t`months`,
  days: t`days`,
  years: t`years`,
};

type DurationUnits = keyof typeof durationUnits;
export function getDurationUnit(unit: DurationUnits) {
  if (durationUnits[unit]) {
    return durationUnits[unit];
  }
  return '';
}

export function calculateMonthDifference(date1: Date, date2: Date) {
  const yearDiff = date2.getFullYear() - date1.getFullYear();
  const monthDiff = date2.getMonth() - date1.getMonth();

  const totalMonthDiff = yearDiff * 12 + monthDiff;

  return Math.max(totalMonthDiff, 1);
}

export function getDurationInMonths(
  duration?: { amount: number; unit: TDateUnit } | null,
) {
  if (!duration) {
    return null;
  }

  switch (duration.unit) {
    case 'days':
      return (duration.amount / 365) * 12;
    case 'months':
      return duration.amount;
    case 'years':
      return duration.amount * 12;
  }
}

export function useFormattedOfferDuration(
  duration: TSingleApplication['formal_offer_sets'][number]['formal_offers'][number]['duration'],
) {
  const { i18n } = useLocale();

  return `${getDurationInMonths(duration)} ${i18n._(
    getDurationUnit('months'),
  )}`;
}
